import { render } from "./AdminCoursesInstructors.vue?vue&type=template&id=54ef7baf&scoped=true"
import script from "./AdminCoursesInstructors.vue?vue&type=script&lang=js"
export * from "./AdminCoursesInstructors.vue?vue&type=script&lang=js"

import "./AdminCoursesInstructors.vue?vue&type=style&index=0&id=54ef7baf&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ef7baf"]])

export default __exports__